export default __webpack_public_path__ + "locales/sr-Latn-RS/Common.json?hash=852eaaa3b58838dec3a4a75d67c35ae7";